import APITemplate from './APITemplate'

const url = '/service-work'
const template = APITemplate(url)

export default {
  ...template,
  archivateItem (id) {
    return fetch(`${url}/archivate?id=${id}`, {
      method: 'PUT',
      credentials: 'include',
      redirect: 'error',
      headers: template.headers
    }).then(response => response.json())
  },
  getActiveServiceWorks () {
    return fetch(`${url}/get-active-service-works`, {
      method: 'PUT',
      credentials: 'include',
      redirect: 'error',
      headers: template.headers
    }).then(response => response.json())
  }
}
